module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/history_list-2a145db11268f6315e3e36e2182db6b7.png";